<template>
  <div class="contact-card">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />

    <Review-Popup
      v-if="showReviewPopup"
      v-on:reviewPopupClosed="showReviewPopup = false"
    />
    <Credit-Limit-Popup
      v-if="showCreditLimitPopup"
      v-on:clickedOutside="showCreditLimitPopup = false"
    />
    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />

    <div class="d-flex line-1-25 top-section">
      <div class="d-flex line-1-25 float-l width-100">
        <div class="width-80 flex-c left-section">
          <div
            class="name float-l width-100 txt-blue"
            v-if="contactData.firstName || contactData.lastName"
          >
            {{ contactData.firstName }} {{ contactData.lastName }}
          </div>
        </div>

        <div class="width-20 flex-c but-holder">
          <!-- show get email button only if domain is present -->
          <span class="margin-auto" v-if="contactData.emailConfidenceScore">
            <Email-confidence-card
              class="fn-14"
              :score="contactData.emailConfidenceScore"
            />
          </span>
        </div>
      </div>
      <div class="title float-l width-100" v-if="contactData.title">
        {{ contactData.title }}
      </div>
      <div
        class="title float-l width-100 email-id"
        v-if="contactData.emailId && canShowButton()"
      >
        <Email-Icon viewBox="2 5 22 12" />
        {{ contactData.emailId }}
      </div>
      <div class="email-hldr" v-if="contactData.emailId && !canShowButton()">
        <Email-Icon viewBox="2 5 22 12" width="15px" height="15px" />
        <div class="email-copy-section">
          <span :class="[{ cursor: !canShowButton() }, 'email noselect']">{{
            contactData.emailId
          }}</span>
          <input
            type="text"
            :value="contactData.emailId"
            class="noVisibility"
            :id="contactData.id + 'email'"
          />
          <Copy-Icon
            v-if="!canShowButton()"
            class="copy-icon"
            @click="copyClipboard(contactData.id, contactData.emailId, 'email')"
          />
        </div>
      </div>
      <div class="flex-c but-holder" v-else-if="contactData.id">
        <Find-Email-Button
          :masterContactId="contactData.id"
          :trigger="triggerFindEmail"
          v-on:response="updatePhoneAndEmail"
          :showUpgradePopup="showUpgradePopup"
          :enableReviewPopup="enableReviewPopup"
          :showActivationPopup="showActivationError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import emailConfidenceCard from '@/components/EmailConfidenceCard.vue'
import findEmailButton from '@/components/FindEmailButton.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import sharedFunctions from './../../assets/util/functions.js'
// import { MxEvent } from './../../assets/util/constants/analytics.js'
import emailIcon from './../../assets/icons/svg/email.svg'
import copyIcon from './../../assets/icons/svg/copy.svg'
// import { post, get } from './../../assets/util/rest.js'
import { post } from './../../assets/util/rest.js'
import UpgradePopup from '@/components/UpgradePopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'

export default {
  name: 'websiteContactCard',
  props: ['contactData', 'ind'],
  data: function () {
    return {
      triggerFindEmail: false,
      errorMsg: null,
      showPopup: false,
      showReviewPopup: false,
      showCreditLimitPopup: false,
      showActivationPopup: false,
    }
  },
  components: {
    'Email-confidence-card': emailConfidenceCard,
    'Email-Icon': emailIcon,
    'Find-Email-Button': findEmailButton,
    'Copy-Icon': copyIcon,
    'Upgrade-Popup': UpgradePopup,
    'Review-Popup': ReviewPopup,
    'Activation-Popup': ActivationPopup,
    'Credit-Limit-Popup': CreditLimitPopup,
  },
  computed: {
    isContactOwned: function () {
      const id = this.contactData.linkedinId
      return this.$store.state.linkedin.bulk.contacts[id].contactAlreadyOwned
    },
  },
  methods: {
    updatePhoneAndEmail(res) {
      this.errorMsg = null
      this.contactData.emailId = res.email
      this.contactData.id = res.masterContactId
      this.contactData.phone = res.phone
      this.contactData.contactAlreadyOwned = true
    },
    findEmail(autoTrigger) {
      if (this.profileData.domain) {
        const reqData = this.constructReqData(this.profileData)
        post('li/adv/profile.htm', reqData)
          .then((response) => {
            if (response.status == 200) {
              response.json().then((res) => {
                if (res) {
                  if (res && res.statusCode === '200') {
                    this.updatePhoneAndEmail(res.response)
                    if (autoTrigger) this.triggerFindEmail = true
                    //get email is automatically clicked
                  } else {
                    this.errorMsg = res.errorMessage
                  }
                }
              })
            }
          })
          .catch((e) => {
            console.log('error: ' + e)
          })
      }
    },
    showActivationError() {
      this.showActivationPopup = true
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    constructReqData(profile) {
      let reqData = {}
      reqData['linkedinId'] = profile['linkedinId']
      reqData['fullName'] = profile['fullName']
      reqData['address'] = profile['address']
      reqData['companyName'] = profile['companyName']
      reqData['title'] = profile['title']
      reqData['domain'] = profile['domain']
      return reqData
    },
    copyClipboard(cId, mail, name) {
      if (!this.canShowButton()) {
        let txtDisplay = 'Copied'
        const dataMap = {
          pageType: 'Website',
        }
        sharedFunctions.clickToCopy(
          cId,
          mail,
          name,
          null,
          dataMap,
          txtDisplay,
          this.$store.state
        )
      }
    },
    canShowButton() {
      return (
        this.contactData &&
        this.contactData.id &&
        this.contactData.emailId.indexOf('*') !== -1
      )
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$default-font: 'Roboto';
.email-id {
  color: $primary-color !important;
  font-size: 14px;
  svg {
    vertical-align: middle;
    fill: $primary-color;
    margin-right: 10px;
    width: 15px;
    height: 15px;
  }
}
.contact-card {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 100%;
  color: $grey-color;
  .title {
    line-height: 22px;
  }

  .error {
    @extend .fn-12;
    @extend .p-t-10p;
    color: $orange;
  }
  .no-company,
  .no-domain {
    border-radius: 18.5px;
    background-color: $orange-light;
    color: $orange;
    padding: 10px;
    font-size: 14px;
    width: fit-content;
    margin-left: -10px;
    margin-top: 5px;
    cursor: pointer;
    svg {
      fill: $orange;
    }
  }

  .company-name {
    padding: 15px 0 5px 0;
    span {
      @extend .icon-img-spacing;
      @extend .ellipsis;
      min-width: 120px;
      max-width: 180px;
    }
  }
  .top-section {
    width: 100%;
    flex-direction: column;
  }
  .name {
    font-size: 15px;
    @extend .ellipsis;
  }
  .title {
    color: $grey-color;
    font-size: 14px;
    padding: 5px 0 10px 0;
    @extend .ellipsis;
  }
  .email-hldr {
    padding-top: 5px;
    display: flex;
    align-items: flex-start;
    color: $primary-color;
    svg {
      fill: $primary-color;
      margin-top: 1px;
    }
    .email-copy-section {
      position: relative;
      display: flex;
    }
    .email {
      font-size: 14px;
      min-width: 80%;
      max-width: 90%;
      word-break: break-word;
      @extend .icon-img-spacing;
    }
    .copy-icon {
      fill: #8e9398;
      width: 12px;
      height: 13px;
      cursor: pointer;
      margin-left: 5px;
    }
    .copied-success {
      color: #484848;
      display: none;
      font-size: 13px;
      margin-left: 6px;
    }
    .show {
      display: block;
    }
  }
  .c-grey {
    color: $grey-color;
  }
  .left-section {
    min-width: 200px;
    @extend .ellipsis;
  }
  .line-1-25 {
    line-height: 1.25;
  }

  .but-holder {
    align-items: start;
    button {
      width: 80px;
      height: 30px;
      border-radius: 3px;
    }
  }
  .but-holder::v-deep {
    .confidence-card {
      padding: 0;
      svg {
        span {
          font-size: 14px;
        }
      }
    }
    svg {
      span.p-5px {
        padding: 0 5px;
      }
    }
    .but {
      border: none;
      padding: 5px 15px;
      border-radius: 20px;
    }
  }
}
</style>
